import {csrfManager} from "../../../../../../lib-sat/csrf/csrf-manager";
import {satGlobals} from "../../../../../sat/helper/sat-globals";
import axios from 'axios';

class FeedbackManager {
    constructor() {

    }

    async submitFeedback(currentJob, rating, message, operation, jobid) {

        const csrfToken = await csrfManager.getCsrfFeedback();
        let feedbackData = {
            operation: operation,
            _csrf: csrfToken,
        };

        feedbackData.job_id = jobid;
        feedbackData.job_status = 'no_status';
        feedbackData.rating = rating;
        feedbackData.feedback = message;

        await axios.post(satGlobals.getApiUrl('/api/feedback'), feedbackData, {withCredentials: true});
    }

    async submitRating(jobid, rating, operation, payload = null) {

        const csrfToken = await csrfManager.getCsrfFeedback();
        let feedbackData = {
            operation: operation,
            _csrf: csrfToken,
        };

        feedbackData.job_id = jobid;
        feedbackData.rating = rating;
        feedbackData.additional_data = payload;

        await axios.post(satGlobals.getApiUrl('/api/feedback_rating'), feedbackData, {withCredentials: true});
    }
}

export default new FeedbackManager();
